import { connect } from 'react-redux'
import ToastManager from './ToastManager'

const mapStateToProps = state => ({
    ...state.toast,
})

export default connect(mapStateToProps)(ToastManager)
